module.exports = __webpack_public_path__ + "static/img/media_pause.4c5f311d.gif";